define(["jquery"], function ($) {

    function DisclaimerBanner(args) {

        $(window).scroll(function () {
            if (args.disappearOnScroll == "true") {
                if ($(window).scrollTop() > 10) {
                    $(args.scope).fadeOut();
                }
            }
        });
        $(".tek-gdpr-accept, .tek-gdpr-decline").click(function () {
            $(args.scope).fadeOut();
        });
    }

    return function init(args) {
        if (!args.isExperienceEditor)
            DisclaimerBanner(args)
    };
});
